<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="chapter"><em>Figures</em></h1>
<p class="para3"><a class="hlink" href="#/OEBPS/c05.htm#fig1">Fig. 1 The Banishing Pentagram of Earth</a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/c06.htm#fig2">Fig. 2 The Invoking Pentagram of Earth</a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/c08.htm#fig3">Fig. 3 The Cabalistic Tree of Life</a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/c09.htm#fig4">Fig. 4 A typical Talisman</a></p>
<p class="para3"><a class="hlink" href="#/OEBPS/ap2.htm#fig5">Fig. 5 The sigil of the name Regardie on the Square of the Sun</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// list.vue?41e9ae9c